import {
  Templates_fields,
  Templates,
} from "./../../../../common/models/templates_model";
import { OpAdminTemplateService } from "./../../../../common/services/op-admin-template.service";
import { Component, OnInit, Input } from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
  FormArray,
  FormBuilder,
} from "@angular/forms";
import { User, user_params } from "src/app/views/common/models/user_model";
import { ToastrService } from "ngx-toastr";
import { OpUsersService } from "src/app/views/common/services/op-users.service";
import { OpSitesService } from "src/app/views/common/services/op-sites.service";
import { OpRolesService } from "src/app/views/common/services/op-roles.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationDialogService } from "src/app/views/common/services/confirmation-dialog.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { callbackify } from "util";
import { log } from "console";

@Component({
  selector: "app-template-field-dialog",
  templateUrl: "./template-field-dialog.component.html",
  styleUrls: ["./template-field-dialog.component.css"],
})
export class TemplateFieldDialogComponent implements OnInit {
  @Input() templateName: any;
  @Input() templateData: any;
  currentTemplateId: any = null;
  action: any;
  isFile: Boolean = false;
  addNew: Boolean = false;
  file: any;
  confirmationDialogService: any;
  showHideFileds: boolean = false;
  showPriceFields: boolean = false;
  showImageFields: boolean = false;
  showPriceOnProductsFields: boolean = false;

  uploadedIndex: number;

  constructor(
    private toastr: ToastrService,
    private route: Router,
    private activeModal: NgbActiveModal,
    private activeRoute: ActivatedRoute,
    private TemplateServ: OpAdminTemplateService,
    private formBuilder: FormBuilder
  ) {}
  fieldForm: FormGroup;
  formFieldValues: [];
  fieldTypeList: any[];
  subfields: FormArray;
  packageFields: FormArray;
  individualFields: FormArray;
  buildTemplateDialogForm() {
    this.fieldForm = new FormGroup({
      id: new FormControl(null),
      code_id: new FormControl(null, Validators.required),
      field_name: new FormControl(null, Validators.required),
      field_value: new FormControl(null),
      position: new FormControl(null),
      required: new FormControl(false),
      edit_by_customer: new FormControl(false),
      subfields: new FormArray([]),
      packageFields: new FormArray([]),
      individualFields: new FormArray([]),
      baseLowPrice: new FormControl(null),
      baseLowPriceStandard: new FormControl(null),
      standardImageLabel: new FormControl(null),
      highImageLabel: new FormControl(null),
    });
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      subFieldId: "",
      subfieldName: "",
      subFieldValue: "",
      subExtraImagePrice: "",
    });
  }
  createPackage(): FormGroup {
    return this.formBuilder.group({
      packageId: "",
      printMountCost: "",
      usbStickCost: "",
    });
  }
  createIndividual(): FormGroup {
    return this.formBuilder.group({
      individualId: "",
      usbStickCost: "",
    });
  }
  addItem(): void {
    this.subfields = this.fieldForm.get("subfields") as FormArray;
    if (this.showPriceOnProductsFields) {
      const index = this.subfields.length;
      const newSubField = this.formBuilder.group({
        subFieldId: "",
        subfieldName: `Price for ${index + 1} image`,
        subFieldValue: "",
        subExtraImagePrice: "",
      });

      this.subfields.push(newSubField);
    } else {
      this.subfields.push(this.createItem());
    }
  }
  removeItem(index) {
    let subFieldItem = this.subfields.value[index];
    let field_Id = this.fieldForm.value.id;
    let sub_field_Id = subFieldItem.subFieldId;
    this.deleteSubField(field_Id, sub_field_Id);
    this.subfields.removeAt(index);

    if (this.showPriceOnProductsFields) {
      // reindex subfield names
      this.subfields.controls.forEach((ctrl, i) => {
        ctrl.get('subfieldName') ? ctrl.get('subfieldName').setValue(`Price for ${i + 1} image`) : null;
      });
    }
  }
  onCancel() {
    this.confirmationDialogService
      .confirm("Confirm Cancel.", "Do you really want cancel Template record ?")
      .then((isConfirmed) => {
        if (isConfirmed == true) {
          this.fieldForm.reset();
          this.activeModal.close(null);
        }
      })
      .catch(() =>
        console.log(
          "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)"
        )
      );
  }

  ngOnInit() {
    this.getFieldTypes();
    this.buildTemplateDialogForm();
    this.activeRoute.queryParams.subscribe((params) => {
      let queryParams = params;
      if (queryParams.action === "edit") {
        this.currentTemplateId = queryParams.id;
        this.action = queryParams.action;
      } else if (queryParams.action === "view") {
        this.currentTemplateId = queryParams.id;
        this.action = queryParams.action;
      }
    });

    if (this.templateData === "") {
      this.addNew = true;
    } else {
      this.templateFieldRecordById(this.templateData.id);
    }
  }

  templateFieldRecordById(templateId) {
    this.TemplateServ.templateFieldRecordById(templateId).subscribe(
      (res: any) => {
        if (res != null) {
          this.patchValue(res.data);
        }
      }
    );
  }

  patchValue(data) {
    if (data.value == "File") {
      this.isFile = true;
    }
    this.patchFieldSelection(data.code_id);
    this.fieldForm.patchValue({
      id: data.id,
      code_id: data.code_id,
      field_name: data.field_name,
      field_value: data.field_value,
      position: data.position,
      required: Boolean(data.required),
      edit_by_customer: Boolean(data.edit_by_customer),
      baseLowPrice: data.baseLowPrice,
      baseLowPriceStandard: data.baseLowPriceStandard,
      standardImageLabel: data.standardImageLabel,
      highImageLabel: data.highImageLabel,
    });
    if (
      data.packageFields != undefined &&
      data.packageFields != null &&
      data.packageFields.length > 0
    ) {
      data.packageFields.forEach((element: any) => {
        let index = data.packageFields.indexOf(element);
        this.packageFields = this.fieldForm.get("packageFields") as FormArray;
        this.packageFields.push(this.createPackage());
        this.packageFields.at(index).patchValue({
          packageId: element.packageId,
          printMountCost: element.printMountCost,
          usbStickCost: element.usbStickCost,
        });
      });
    }
    if (
      data.individualFields != undefined &&
      data.individualFields != null &&
      data.individualFields.length > 0
    ) {
      data.individualFields.forEach((element: any) => {
        let index = data.individualFields.indexOf(element);
        this.individualFields = this.fieldForm.get(
          "individualFields"
        ) as FormArray;
        this.individualFields.push(this.createIndividual());
        this.individualFields.at(index).patchValue({
          individualId: element.individualId,
          usbStickCost: element.usbStickCost,
        });
      });
    }
    if (data.is_sub_field == true) {
      if (
        data.subfields != undefined &&
        data.subfields != null &&
        data.subfields.length > 0
      ) {
        data.subfields.forEach((element: any) => {
          let index = data.subfields.indexOf(element);
          this.subfields = this.fieldForm.get("subfields") as FormArray;
          this.subfields.push(this.createItem());
          this.subfields.at(index).patchValue({
            subFieldId: element.subFieldId,
            subfieldName: element.subfieldName,
            subFieldValue: element.subFieldValue,
            subExtraImagePrice: element.subExtraImagePrice,
          });
        });
      }
    }
  }
  patchFieldSelection(code_id) {
    this.subfields = this.fieldForm.get("subfields") as FormArray;
    this.subfields.clear();
    this.subfields = null;
    this.showHideFileds = false;
    this.showPriceFields = false;
    this.showPriceOnProductsFields = false;
    this.showImageFields = false;
    this.TemplateServ.getCodeList("Field_Types").subscribe((res: any) => {
      this.fieldTypeList = res.data;
      this.fieldTypeList.forEach((element: any) => {
        if (element.value == "File") {
          const index = this.fieldTypeList.indexOf(element);
          this.fieldTypeList.splice(index, 1);
        }
      });
      this.fieldTypeList.forEach((element: any) => {
        if (code_id == element.id) {
          if (element.value == "File") {
            this.isFile = true;
          }
          if (element.value == "Price") {
            this.showHidePriceAndImageFields("Price");
          }
          if (element.value == "Image") {
            this.showHidePriceAndImageFields("Image");
          }
          if (element.value == "PriceByProductNo") {
            this.showHidePriceByProductNoFields();
          }
        }
      });
    });
  }
  onFieldSelection(event) {
    this.subfields = this.fieldForm.get("subfields") as FormArray;
    this.subfields.clear();
    this.subfields = null;
    this.showHideFileds = false;
    this.showPriceFields = false;
    this.showPriceOnProductsFields = false;
    this.showImageFields = false;
    this.fieldTypeList.forEach((element: any) => {
      if (event == element.id) {
        if (element.value == "File") {
          this.isFile = true;
        }
        if (element.value == "Price") {
          this.showHidePriceAndImageFields("Price");
        }
        if (element.value == "Image") {
          this.showHidePriceAndImageFields("Image");
        }
        if (element.value == "PriceByProductNo") {
          this.showHidePriceByProductNoFields();
        }
      }
    });
  }
  public reset() {
    this.fieldForm.reset();
  }
  getFieldTypes() {
    this.TemplateServ.getCodeList("Field_Types").subscribe((res: any) => {
      this.fieldTypeList = res.data;
      this.fieldTypeList.forEach((element: any) => {
        if (element.value == "File") {
          const index = this.fieldTypeList.indexOf(element);
          this.fieldTypeList.splice(index, 1);
        }
      });
    });
  }

  uploadFile(eventFile) {
    if (eventFile != null || eventFile != undefined) {
      this.file = eventFile[0];
    }
  }
  onSubmit(formValues) {
    if (this.action == "edit") {
      if (this.isFile == true) {
        this.addOrUpdateFileFieldInTemplate(formValues);
      } else {
        this.addOrUpdateFieldInTemplate(formValues);
      }
    } else {
      this.addTemplateWithFirstField(formValues);
    }
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  handleFile(event) {
    var binaryString = event.target.result;
    binaryString = binaryString.replace(
      /^data:image\/(png|jpeg|jpg);base64,/,
      ""
    );
    this.subfields = this.fieldForm.get("subfields") as FormArray;
    this.subfields.at(this.uploadedIndex).patchValue({
      subFieldValue: binaryString,
    });
  }

  addFileToFormArray(event, index) {
    this.uploadedIndex = index;
    var files = event.target.files;
    var file = files[0];
    if (files && file) {
      var reader = new FileReader();
      reader.onload = this.handleFile.bind(this);
      reader.readAsDataURL(file);
    }
  }

  showHidePriceAndImageFields(selectedFieldType) {
    if (selectedFieldType == "Price") {
      this.showHideFileds = true;
      this.showPriceFields = true;
      this.showImageFields = false;
      this.showPriceOnProductsFields = false;
    }
    if (selectedFieldType == "Image") {
      this.showHideFileds = true;
      this.showImageFields = true;
      this.showPriceFields = false;
      this.showPriceOnProductsFields = false;
    }
  }
  showHidePriceByProductNoFields() {
    this.showHideFileds = true;
    this.showPriceOnProductsFields = true;
    this.showPriceFields = false;
    this.showImageFields = false;
  }
  addOrUpdateFileFieldInTemplate(formValues) {
    let templateData = this.prepareFormDataBody(formValues);
    this.TemplateServ.saveOrUpdateFileFieldInTemplate(templateData).subscribe(
      (res: any) => {
        this.toastr.success(
          "Template field added/updated Successfully",
          "Template",
          {
            positionClass: "toast-top-center",
          }
        );
        this.route.navigate(["/AdminPanel/add-templates"], {
          queryParams: {
            id: this.currentTemplateId,
            action: "edit",
            name: templateData.get("name"),
          },
        });
        this.activeModal.close(true);
      }
    );
  }

  addTemplateWithFirstField(formValues) {
    let templateData = this.prepareFormDataBody(formValues);
    this.TemplateServ.saveTemplate(templateData).subscribe((res: any) => {
      this.toastr.success("Template field Added Successfully", "Template", {
        positionClass: "toast-top-center",
      });
      this.route.navigate(["/AdminPanel/add-templates"], {
        queryParams: {
          id: res.data,
          action: "edit",
          name: templateData.get("name"),
        },
      });
      this.activeModal.close(true);
    });
  }

  addOrUpdateFieldInTemplate(formValues) {
    let templateData = this.prepareUpdateBody(formValues);
    console.log(templateData);
    this.TemplateServ.updateTemplate(templateData).subscribe((res: any) => {
      this.toastr.success("Template field Update Successfully", "Template", {
        positionClass: "toast-top-center",
      });
      this.activeModal.close(true);
    });
  }

  deleteSubField(fieldId, subFieldId) {
    this.TemplateServ.deleteSubField(fieldId, subFieldId).subscribe(
      (res: any) => {
        this.toastr.success("SubField removed Successfully", "Template", {
          positionClass: "toast-center-center",
        });
      }
    );
  }

  prepareBody(formValues) {
    for (const key in formValues) {
      if (formValues.hasOwnProperty(key)) {
        const element = formValues[key];
        if (element == undefined) {
          formValues[key] = null;
        }
      }
    }
    let template_params: Templates = {
      template_id: null,
      name: "",
      fields: [],
    };
    template_params.name = this.templateName;
    let fields_params: Templates_fields = {
      id: null,
      code_id: null,
      code_value: null,
      field_name: null,
      field_value: null,
      position: null,
      required: null,
      edit_by_customer: null,
      subfields: [],
      packageFields: [],
      individualFields: [],
      is_sub_field: false,
      baseLowPrice: null,
      baseLowPriceStandard: null,
      standardImageLabel: null,
      highImageLabel: null,
    };
    fields_params.id = formValues.id;
    fields_params.code_id = formValues.code_id;
    fields_params.field_name = formValues.field_name;
    fields_params.baseLowPrice = formValues.baseLowPrice;
    fields_params.baseLowPriceStandard = formValues.baseLowPriceStandard;
    fields_params.standardImageLabel = formValues.standardImageLabel;
    fields_params.highImageLabel = formValues.highImageLabel;
    fields_params.field_value = formValues.field_value;
    fields_params.position = formValues.position;
    fields_params.required = String(formValues.required);
    fields_params.edit_by_customer = String(formValues.edit_by_customer);
    fields_params.is_sub_field = this.showHideFileds;
    fields_params.subfields = formValues.subfields;
    template_params.fields.push(fields_params);
    return template_params;
  }

  prepareUpdateBody(formValues) {
    for (const key in formValues) {
      if (formValues.hasOwnProperty(key)) {
        const element = formValues[key];
        if (element == undefined) {
          formValues[key] = null;
        }
      }
    }
    let template_params: Templates = {
      template_id: null,
      name: "",
      fields: [],
    };
    template_params.name = this.templateName;
    let fields_params: Templates_fields = {
      id: null,
      code_id: null,
      code_value: null,
      field_name: null,
      field_value: null,
      position: null,
      required: null,
      edit_by_customer: null,
      subfields: [],
      packageFields: [],
      individualFields: [],
      is_sub_field: false,
      baseLowPrice: null,
      baseLowPriceStandard: null,
      standardImageLabel: null,
      highImageLabel: null,
    };
    fields_params.id = formValues.id;
    fields_params.code_id = formValues.code_id;
    fields_params.field_name = formValues.field_name;
    fields_params.baseLowPrice = formValues.baseLowPrice;
    fields_params.baseLowPriceStandard = formValues.baseLowPriceStandard;
    fields_params.standardImageLabel = formValues.standardImageLabel;
    fields_params.highImageLabel = formValues.highImageLabel;
    fields_params.field_value = formValues.field_value;
    fields_params.position = formValues.position;

    fields_params.is_sub_field = this.showHideFileds;

    if (this.showPriceFields == true) {
      fields_params.required = "true";
      fields_params.edit_by_customer = "true";
    } else {
      fields_params.required = String(formValues.required);
      fields_params.edit_by_customer = String(formValues.edit_by_customer);
    }
    fields_params.packageFields = formValues.packageFields;
    fields_params.individualFields = formValues.individualFields;
    fields_params.subfields = formValues.subfields;
    template_params.fields.push(fields_params);
    template_params.template_id = this.currentTemplateId;
    return template_params;
  }

  prepareFormDataBody(formValues) {
    const templateFormData = new FormData();
    templateFormData.append("name", this.templateName);
    templateFormData.append("id", formValues.id);
    templateFormData.append("template_id", this.currentTemplateId);
    templateFormData.append("code_id", formValues.code_id);
    templateFormData.append("field_name", formValues.field_name);
    templateFormData.append("baseLowPrice", formValues.baseLowPrice);
    templateFormData.append("baseLowPriceStandard", formValues.baseLowPriceStandard);
    templateFormData.append("standardImageLabel", formValues.standardImageLabel);
    templateFormData.append("highImageLabel", formValues.highImageLabel);
    if (this.isFile == true) {
      templateFormData.append("field_value", this.file);
    } else {
      templateFormData.append("field_value", formValues.field_value);
    }
    templateFormData.append("is_sub_field", this.showHideFileds.toString());

    templateFormData.append(
      "packageFields",
      JSON.stringify(formValues.packageFields)
    );
    templateFormData.append(
      "individualFields",
      JSON.stringify(formValues.individualFields)
    );
    templateFormData.append("subfields", JSON.stringify(formValues.subfields));
    templateFormData.append("position", formValues.position);
    if (this.showPriceFields == true) {
      templateFormData.append("required", "true");
      templateFormData.append("edit_by_customer", "true");
    } else {
      templateFormData.append("required", formValues.required);
      templateFormData.append("edit_by_customer", formValues.edit_by_customer);
    }
    return templateFormData;
  }

  addPackageItem(): void {
    this.packageFields = this.fieldForm.get("packageFields") as FormArray;
    this.packageFields.push(this.createPackage());
  }

  addIndividualItem(): void {
    this.individualFields = this.fieldForm.get("individualFields") as FormArray;
    this.individualFields.push(this.createIndividual());
  }

  removePackageItem(index) {
    let packageItem = this.packageFields.value[index];
    let field_id = this.fieldForm.value.id;
    let package_field_Id = packageItem.packageId;
    this.deletePackageSubField(field_id, package_field_Id);
    this.packageFields.removeAt(index);
  }
  removeIndividualItem(index) {
    console.log(index);
    let individualItem = this.individualFields.value[index];
    let field_id = this.fieldForm.value.id;
    let package_field_Id = individualItem.individualId;
    this.deleteIndividualField(field_id, package_field_Id);
    this.individualFields.removeAt(index);
  }
  deleteIndividualField(fieldId, individualID) {
    this.TemplateServ.deleteIndividualField(fieldId, individualID).subscribe(
      (res: any) => {
        this.toastr.success(
          "Individual Field removed Successfully",
          "Template",
          {
            positionClass: "toast-center-center",
          }
        );
      }
    );
  }
  deletePackageSubField(fieldId, packageID) {
    this.TemplateServ.deletePackageField(fieldId, packageID).subscribe(
      (res: any) => {
        this.toastr.success("Package Field removed Successfully", "Template", {
          positionClass: "toast-center-center",
        });
      }
    );
  }
}
